import { SeatLegroomNormalIcon } from './SeatLegroomNormalIcon';

/**
 * author: Google
 * id 1FC39B1E-567E-452C-B923-581F9A90F06D
 * name seat-legroom-normal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-legroom-normal.svg
 * tags
 */
export const AirlineSeatLegroomNormalIcon = SeatLegroomNormalIcon;
export default AirlineSeatLegroomNormalIcon